const def = (state = { cards: [] }, action) => {
    switch (action.type) {
        case "FETCH_SET":
            return Object.assign({}, { cards: action.payload });
        default:
            return state;
    }
}

export default def;